import { Link, useLocation } from "@tanstack/react-router";
import { Link2, RefreshCw } from "lucide-react";
import { cn } from "@/lib/utils";

const integrationsTabs = [
  { label: "Synchronizations", href: "/dashboard/integrations/sync", icon: RefreshCw },
  { label: "Solution → Demand Links", href: "/dashboard/integrations/demands", icon: Link2 },
];

export function IntegrationsLayout({ children }: { children: React.ReactNode }) {
  const location = useLocation();

  return (
    <div className="px-6 py-5">
      {/* Header */}
      <div className="mb-8">
        <h1 className="font-display text-3xl font-bold">Integrations</h1>
        <p className="mt-1 text-muted-foreground">
          Sync data from the Nymbl Platform and review each Solution's linked NOS Demands.
        </p>
      </div>

      {/* Tab navigation */}
      <div className="relative mb-8">
        <div className="-mx-6 px-6 overflow-x-auto md:mx-0 md:px-0 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          <nav className="flex gap-1 whitespace-nowrap">
            {integrationsTabs.map((tab) => {
              const isActive = location.pathname === tab.href;

              return (
                <Link
                  key={tab.href}
                  to={tab.href}
                  role="tab"
                  aria-selected={isActive}
                  className={cn(
                    "group relative flex items-center gap-2 px-4 py-2.5 text-sm font-medium transition-colors rounded-md",
                    isActive ? "text-foreground" : "text-muted-foreground hover:text-foreground/80",
                  )}
                >
                  <tab.icon
                    className={cn(
                      "h-4 w-4 transition-colors",
                      isActive
                        ? "text-primary"
                        : "text-muted-foreground/60 group-hover:text-muted-foreground",
                    )}
                  />
                  <span>{tab.label}</span>

                  {/* Active indicator */}
                  {isActive && (
                    <span className="absolute bottom-0 left-3 right-3 h-0.5 rounded-full bg-primary" />
                  )}
                </Link>
              );
            })}
          </nav>
        </div>

        {/* Baseline border */}
        <div className="absolute bottom-0 left-0 right-0 h-px bg-border" />
      </div>

      {/* Tab content */}
      {children}
    </div>
  );
}
